(ns practitest.frontend.active-sessions.subs
  (:require [re-frame.core :as re-frame]))

;; TODO: once device-connection-based online/offline ping will be implemented,
;;       we will need to refactor this too
(def ^:private presence-ping-interval-ms 30000)

;; NOTE: A session counts as active only if its last active ping is within this window
;;       Older than that we render it as idle.
;;       Just needs to exceed the ping interval by enough to absorb a missing ping or jitter.
(def ^:private active-window-ms (* 4 presence-ping-interval-ms))

(re-frame/reg-sub ::state (fn [db _] (:active-sessions db)))
(re-frame/reg-sub ::init-complete? :<- [::state] (fn [s _] (boolean (:init-complete? s))))
(re-frame/reg-sub ::sessions :<- [::state] (fn [s _] (:sessions s)))
(re-frame/reg-sub ::show-idle? :<- [::state] (fn [s _] (boolean (:show-idle? s))))
(re-frame/reg-sub ::total-licenses :<- [::state] (fn [s _] (:total-licenses s)))
(re-frame/reg-sub ::used-licenses :<- [::state] (fn [s _] (:used-licenses s)))

(re-frame/reg-sub
  ::sessions-with-state
  :<- [::sessions]
  (fn [sessions _]
    (let [now (js/Date.now)]
      (mapv (fn [{:keys [state last_active_time] :as session}]
              (assoc session :state
                     (if (and (= state "active")
                              (<= (- now last_active_time) active-window-ms))
                       "active"
                       "idle")))
            sessions))))

(defn- active? [{:keys [state]}]
  (= "active" state))

(re-frame/reg-sub
  ::visible-sessions
  :<- [::sessions-with-state]
  :<- [::show-idle?]
  (fn [[sessions show-idle?] _]
    (if show-idle?
      sessions
      (filterv active? sessions))))

(re-frame/reg-sub
  ::active-count
  :<- [::sessions-with-state]
  (fn [sessions _]
    (count (filter active? sessions))))

(re-frame/reg-sub
  ::idle-count
  :<- [::sessions-with-state]
  (fn [sessions _]
    (count (remove active? sessions))))

